<template>
  <div>
    <div class="form-wrap">
      <!-- お子様一覧 -->
      <div class="row mx-5-gutters child-select-area" v-for="child_infos in child_infos_chunk">
          <div class="col-4" v-for="child_info in child_infos">
            <div class="child-select-item" style="height:100%;">
              <router-link tag="button" style="height:80%;" class="btn btn-outline-success btn-child my-2 btn-child w-100 text-left" :to="{ name: 'mypage::child_info::detail', params: {child_info_id:child_info.id} }" >
                {{child_info.family_name}} {{child_info.given_name}}
              </router-link>
            </div>
        </div>
      </div>

      <div class="form-list py-3">
        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.family_name.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui['5_3'][2]"/></label>
          <div class="col-7">
            <input class="form-control transparent-input" type="text" value="" placeholder="Yamada" v-model="input.family_name" @change="$v.input.family_name.$touch()">
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.family_name" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['5_3'][1]"/></input-feedback>
          </p>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.given_name.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui['5_3'][3]"/></label>
          <div class="col-7">
            <input class="form-control transparent-input" type="text" value="" placeholder="Taro" v-model="input.given_name" @change="$v.input.given_name.$touch()">
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.given_name" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['5_3'][2]"/></input-feedback>
          </p>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.school_name.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui['5_3'][4]"/></label>
          <div class="col-7">
            <input class="form-control transparent-input" type="text" value="" placeholder="oo school" v-model="input.school_name" @change="$v.input.school_name.$touch()">
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.school_name" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['5_3'][3]"/></input-feedback>
          </p>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.group_name.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui['5_3'][5]"/></label>
          <div class="col-7">
            <input class="form-control transparent-input" type="text" value="" placeholder="A" v-model="input.group_name" @change="$v.input.group_name.$touch()">
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.group_name" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['5_3'][4]"/></input-feedback>
          </p>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.family_relation_id.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui['5_3'][6]"/></label>
          <div class="col-7">
            <select class="custom-select mb-2" v-model="input.family_relation_id" @change="$v.input.family_relation_id.$touch()">
              <option :value="family_relation.id" v-for="family_relation in family_relations">{{family_relation.name}}</option>
            </select>
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.family_relation_id" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['5_3'][5]"/></input-feedback>
          </p>

          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- フォーム送信UI -->
        <div class="row text-center" v-if="isShowAddBtn">
          <div class="offset-1 col-5" >
            <div class="my-2">
              <button type="button" class="btn w-100 btn-lg btn-default" @click="deleteForm">
                <trans-text i18nKey="ui['5_3'][7]"/>
              </button>
            </div>
          </div>
          <div class="col-5">
            <div class="my-2">
              <button type="button" class="btn w-100 btn-lg btn-warning" @click="tryForm">
                <trans-text i18nKey="ui['5_3'][8]"/>
              </button>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="offset-3 col-6">
            <div class="my-2">
              <button type="button" class="btn w-100 btn-lg btn-warning" @click="tryForm">
                <trans-text i18nKey="ui['5_3'][8]"/>
              </button>
            </div>
          </div>

        </div>

        <!-- フォーム送信UI -->
        <div class="row text-center" v-if="isShowAddBtn">
          <div class="offset-1 offset-sm-2 offset-md-3 col-10 col-sm-8 col-md-6">
            <div class="my-2">
              <p><trans-text i18nKey="ui['5_3'][9]"/></p>
              <router-link tag="button"class="btn w-100 btn-lg btn-danger" :to="{ name: 'mypage::child_info', params: {} }" >
                <trans-text i18nKey="ui['5_3'][10]"/>
              </router-link>
            </div>
          </div>
        </div>

      </div>
      <child-delete-confirm-modal :input="input" @remove="remove"></child-delete-confirm-modal>
    </div>

  </div>

</template>

<script>
  import {dd,store,app} from 'systems/imports'

  import FormPartialBase from 'extends/FormPartialBase.vue'
  import {required,email,minLength,alphaNum,sameAs} from 'systems/validators'
  import ChildDeleteConfirmModal from 'components/modal/ChildDeleteConfirmModal.vue'

  /** @see page_subPages_MyPage_ChildInfo */
  export default {
    extends:FormPartialBase,
    props:["family_relations","child_infos"],
    components: {
      ChildDeleteConfirmModal,
    },
    data () {
      return {
        input: {
          family_name: "",
          given_name: "",
          school_name:"",
          group_name:"",
          family_relation_id:"1",
        },
      }
    },
    validations: {
      input: {
        family_name: {
          required
        },
        given_name: {
          required
        },
        school_name: {
          required,
        },
        group_name: {
          required
        },
        family_relation_id: {
          required,
        },
      },
    },
    mounted(){
      this.$v.$reset()
    },
    computed:{
      isShowAddBtn(){
        return this.$route.params.child_info_id > 0
      },
      child_infos_chunk(){
          return app.make("_").chunk(this.child_infos,3)
      },
      current_child_info(){
        let childInfoId = this.$route.params.child_info_id
        let child_info = app.make("_").find(this.child_infos,(o)=>{
          return Number(o.id) === Number(childInfoId)
        })

        return child_info || {
          family_name: "",
            given_name: "",
            school_name:"",
            group_name:"",
            family_relation_id:"1",
        }
      }
    },
    watch: {
      '$route' (to, from) {
        this.$v.$reset()
      },
      current_child_info(val,){
        Object.assign(this.input, (val ? val : {}))
      },
    },
    methods:{
      deleteForm(e){
        $("#ChildDeleteConfirmModal").modal({backdrop: 'static', keyboard: false})
      },
      tryForm(e){
        //バリデーション
        if(this.$v.input.$invalid){
          this.$v.input.$touch()
          return
        }
        this.$emit('tryForm', this.input)
      },
      remove(){
        this.$emit("remove")
      }
    }
  }
</script>

<style lang="scss" scoped>
  .child-select-item .router-link-active {
    color: #fff;
    background-color: #82ba1d !important;
    &:before {
      color: #fff !important;
    }
  }

  .child-select-area{

    .child-select-item{
      .btn-child{
        background-color: #fff;
        padding-left: 2rem;
        position: relative;
        white-space:normal !important;
        word-wrap:break-word;
        &:before{
          font-family: FontAwesome;
          content: '\f007';
          font-size:1.2rem;
          color: #82ba1d;
          position: absolute;
          top: 50%;
          transform: translateY(-50%) translateX(0);
          left: 5%;
        }
        &:hover{
          background-color: #72b400;
          color: #fff;
          &:before{
            color: #fff;
          }
        }

      }

    }
  }

</style>



// WEBPACK FOOTER //
// PageForm.vue?3b5cf39c